import { useEffect } from "react";

import { useNavigate } from "@remix-run/react";

// AIDEV-NOTE: A plain <a href="#id"> pushes a history entry with no router state, so
// React Router reads the popstate as location key "default" and <ScrollRestoration>
// restores the position it saved for that key — scrolling the user straight back
// after the browser's native jump. (Second click on the same hash fires no popstate,
// which is why "click twice" worked.) Routing same-page hash clicks through the
// router gives them a real key, and ScrollRestoration then scrolls to the hash.
export function HashLinkRouter() {
    const navigate = useNavigate();
    useEffect(() => {
        const onClick = (event: MouseEvent) => {
            if (
                event.defaultPrevented ||
                event.button !== 0 ||
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey
            ) {
                return;
            }
            const anchor = (event.target as Element | null)?.closest?.("a");
            if (!anchor || anchor.target === "_blank") return;
            const href = anchor.getAttribute("href");
            if (!href || !href.startsWith("#") || href === "#") return;
            event.preventDefault();
            navigate(
                {
                    pathname: location.pathname,
                    search: location.search,
                    hash: href,
                },
                { preventScrollReset: false },
            );
        };
        document.addEventListener("click", onClick);
        return () => document.removeEventListener("click", onClick);
    }, [navigate]);
    return null;
}
